import React from 'react';

// Mobx
import { inject, observer } from 'mobx-react';

// Navigation
import { useNavigate } from 'react-router-dom';

// Helpers
import Helpers from '../helpers';

@inject('AuthStore')
@observer

class Logout extends React.Component<any> {
    constructor(props: any) {
        super(props);
    }

    componentDidMount(): void {
        Helpers.logout();
    }

    render() {
        return (
            <></>
        )
    }
}

function WithNavigate(props: any) {
    let navigate = useNavigate();
    return <Logout {...props} navigate={navigate} />
}

export default WithNavigate